import { convert as htmlToText } from 'html-to-text'
import { MailboxItemDirection, MailboxItemStatus } from '../../api-clients/mailbox'
import { getTexts } from '../../i18l'

export const PAGE_SIZE = 20
export const MAILBOX_ORIGIN = 2

export function directionLabel(d?: MailboxItemDirection): string {
    const td = getTexts().inbox.direction
    if (d === MailboxItemDirection.NUMBER_1) return td.in
    if (d === MailboxItemDirection.NUMBER_0) return td.out
    return '—'
}

export function statusColor(s?: MailboxItemStatus): string {
    switch (s) {
        case MailboxItemStatus.NUMBER_1: return 'info'       // Queued
        case MailboxItemStatus.NUMBER_2: return 'primary'    // Sent
        case MailboxItemStatus.NUMBER_3: return 'success'    // Delivered
        case MailboxItemStatus.NUMBER_4: return 'danger'     // Failed
        case MailboxItemStatus.NUMBER_5: return 'secondary'  // Received
        case MailboxItemStatus.NUMBER_6: return 'success'    // Read
        default: return 'secondary'
    }
}

export function statusLabel(s?: MailboxItemStatus): string {
    const ts = getTexts().inbox.status
    switch (s) {
        case MailboxItemStatus.NUMBER_1: return ts.queued
        case MailboxItemStatus.NUMBER_2: return ts.sent
        case MailboxItemStatus.NUMBER_3: return ts.delivered
        case MailboxItemStatus.NUMBER_4: return ts.failed
        case MailboxItemStatus.NUMBER_5: return ts.received
        case MailboxItemStatus.NUMBER_6: return ts.read
        default: return '—'
    }
}

export function formatFileSize(bytes?: number): string {
    if (!bytes) return ''
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function htmlToPlainText(html?: string | null): string {
    if (!html) return ''
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

export function bodyPreview(html?: string | null, maxChars = 90): string {
    if (!html) return ''
    const plain = htmlToText(html, {
        wordwrap: false,
        selectors: [
            { selector: 'a', options: { ignoreHref: true } },
            { selector: 'img', format: 'skip' },
            { selector: 'hr', format: 'skip' },
            { selector: 'h1', options: { uppercase: false } },
            { selector: 'h2', options: { uppercase: false } },
            { selector: 'h3', options: { uppercase: false } },
        ],
    }).replace(/\s+/g, ' ').trim()
    return plain.length > maxChars ? plain.slice(0, maxChars) + '…' : plain
}

export function footerBlockHtml(footer?: string | null): string {
    if (!footer?.trim()) return ''
    return `<p><br></p><hr/><div data-mail-footer="true">${footer}</div>` // i18n-ignore (markup)
}

const STATUS_DOT_COLORS: Record<number, [string, string]> = {
    1: ['#e8f0fe', '#1a73e8'],
    2: ['#eaf4ef', '#2d7d5b'],
    3: ['#eaf4ef', '#2d7d5b'],
    4: ['#fdecea', '#c0392b'],
    5: ['#fdf3e9', '#8b5e2e'],
    6: ['#eaf4ef', '#2d7d5b'],
}

export function getStatusDotColors(s?: MailboxItemStatus): [string, string] {
    return STATUS_DOT_COLORS[s as number] ?? ['#f0f0f0', '#888']
}
